import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.authentikAuthority,
  clientId: environment.authentikClientId,
  redirectUri: window.location.origin + '/callback',
  responseType: 'code',
  scope: 'openid profile email offline_access',
  showDebugInformation: !environment.production,
  postLogoutRedirectUri: window.location.origin + '/login?reason=loggedout',
  clearHashAfterLogin: false,
  strictDiscoveryDocumentValidation: false,
};
